var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23026 0.776377C8.19509 -0.258792 6.50962 -0.258792 5.47445 0.776377L2.46848 3.78235C2.1566 4.09423 1.98407 4.51228 1.98407 4.95687C1.98407 5.40146 2.1566 5.81951 2.46848 6.13139C2.79363 6.45654 3.21831 6.61579 3.643 6.61579C4.06768 6.61579 4.49237 6.45654 4.81752 6.13139L6.22429 4.72462C6.48308 4.45919 6.61579 4.12741 6.61579 3.78898C6.61579 3.45056 6.48972 3.11214 6.22429 2.85335L3.87525 5.19575C3.74917 5.32183 3.53683 5.32183 3.40411 5.19575C3.31785 5.10949 3.30458 5.01659 3.30458 4.9635C3.30458 4.91042 3.31785 4.81088 3.40411 4.73125L6.41009 1.71865C6.92767 1.20106 7.77041 1.20106 8.28799 1.71865C8.80557 2.23623 8.80557 3.07896 8.28799 3.59655L5.27538 6.60916L3.59655 8.28799C3.07897 8.80557 2.23623 8.80557 1.71865 8.28799C1.20106 7.7704 1.20106 6.92767 1.71865 6.41009L1.77837 6.34373C1.47976 5.94559 1.31387 5.44127 1.31387 4.93696L0.776377 5.47445C-0.258792 6.50962 -0.258792 8.19509 0.776377 9.23026C1.29396 9.74784 1.9708 10.0066 2.65428 10.0066C3.33776 10.0066 4.0146 9.74784 4.53218 9.23026L9.22362 4.53882C10.2588 3.50365 10.2588 1.81818 9.22362 0.783013L9.23026 0.776377Z",
    fill: "#0091FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.8ef6a15cbb2fdda94549681d3a0f8363.svg";
export { ForwardRef as ReactComponent };